import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { env } from '@/lib/env'

// Not under automation: the two floating buttons sit over the foot of the rail, and a Playwright
// click on the account menu lands on the query devtools instead.
const Devtools =
  env.DEV && !navigator.webdriver
    ? lazy(async () => {
        const [{ TanStackRouterDevtools }, { ReactQueryDevtools }] = await Promise.all([
          import('@tanstack/react-router-devtools'),
          import('@tanstack/react-query-devtools'),
        ])
        return {
          default: () => (
            <>
              <TanStackRouterDevtools position="bottom-right" />
              <ReactQueryDevtools buttonPosition="bottom-left" />
            </>
          ),
        }
      })
    : () => null

type RouterContext = {
  queryClient: QueryClient
}

// The app shell lives under `_app` (signed-in routes); `login` and `sign-up` render bare.
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => (
    <div className="p-6 text-center text-muted-foreground">Page not found.</div>
  ),
})

function RootLayout() {
  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <Devtools />
      </Suspense>
    </>
  )
}
